import store from '@/store'
import i18n from '@/i18n/config.js'
import ResponseConstant from '@/constants/responseConstant'

export function checkPermission(permissionsRequired) {
  return store.getters['auth/hasPermission'](permissionsRequired)
}

export const displayToast = (message, color) => {
  store.commit('snackbar/showSnackbar', { text: message, color: color })
}

export const handleResponseError = (error, toastType = 'error', isItech = false) => {
  if (!error) {
    displayToast(i18n.global.t('ERROR_STATUS_CODE_MESSAGE.UNKNOWN'), toastType)
    return
  }

  const response = error?.response
  const errorKey = response?.data?.key
  const errorParams = response?.data?.params
  const errorStatus = response?.status

  if (errorKey && errorKey in ResponseConstant) {
    displayToast(
      i18n.global.t('ERROR.' + ResponseConstant[errorKey], {
        params: errorParams !== undefined ? errorParams : null
      }),
      toastType
    )
  } else {
    const errorKey = isItech
      ? 'ERROR.ITECH_GENERIC_ERROR_KEY'
      : 'ERROR_STATUS_CODE_MESSAGE.' + (response ? errorStatus : 'UNKNOWN')

    displayToast(i18n.global.t(errorKey), toastType)
  }
}

export function shouldShowTooltip(item, selectElement) {
  const containerElement = document.getElementById(selectElement)
  const titleElement = document.createElement('span')

  titleElement.style.position = 'fixed'
  titleElement.style.visibility = 'hidden'
  titleElement.style.whiteSpace = 'nowrap'
  titleElement.style.fontSize = '1rem'
  titleElement.style.fontWeight = '400'
  titleElement.style.letterSpacing = '.009375em'
  titleElement.style.lineHeight = '1.5rem'

  titleElement.innerText = item.title
  document.body.appendChild(titleElement)

  // get icon and other stuff build in process for getting parent v select size instead of input inside v select
  // 28 + 12
  // and remove padding right end left
  // - 16 - 16
  const containerWidth = containerElement.offsetWidth + 8
  const titleWidth = titleElement.offsetWidth

  document.body.removeChild(titleElement)

  return titleWidth > containerWidth
}

export function getEmailPattern() {
  return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9._+-]+\.[a-zA-Z]{2,7}$/
}

export function capitalizeFirstLetter(string) {
  const lowerCaseString = string.toLowerCase()

  return lowerCaseString.charAt(0).toUpperCase() + lowerCaseString.slice(1)
}

export const formatDate = (dateString) => {
  const date = new Date(dateString)

  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }

  return date.toLocaleString('fr-FR', options)
}

export const convertDateFromInput = (date) => {
  if (!date) return null

  const parsedDate = new Date(date)

  if (isNaN(parsedDate.getTime())) {
    return null
  }

  const localDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000)

  return localDate.toISOString().split('T')[0]
}
